import { Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import styled from "styled-components";

export const AGI_GRID_COLUMNS =
  "minmax(220px, 2fr) repeat(4, minmax(100px, 1fr)) 24px";

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.sm}px;
  width: 100%;
  border-radius: 16px;
`;

export const RowOuter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ClickableRow = styled.div`
  display: grid;
  grid-template-columns: ${AGI_GRID_COLUMNS};
  column-gap: 10px;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;

export const ExpandedSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: ${Spacing.sm}px;
  padding-top: ${Spacing.sm}px;
  border-top: 1px solid ${ColorV2.Blue6};
`;
